// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: 'AIzaSyAhrjrY8eAaG6up3FYzMBJMinxTGAjjpQ0',
    authDomain: 'streaming-website-8198f.firebaseapp.com',
    projectId: 'streaming-website-8198f',
    storageBucket: 'streaming-website-8198f.appspot.com',
    messagingSenderId: '228930366638',
    appId: '1:228930366638:web:f880ea5e672e7e6fc5913f',
    measurementId: 'G-1ZGQ1GKYVY',
    // databaseURL: 'streaming-website-8198f.firebaseio.com',
  },
  recaptcha: {
    siteKey: '6LcI4EkkAAAAAM5IXYpQajGH_R118naEg40uBgaP',
  },
  production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
